import {createRouter, createWebHashHistory, createWebHistory} from "vue-router";
import ReservationView from "@/book/views/ReservationView.vue";


const routes = [
	{
		path: "/",
		component: ReservationView,
	},
	{
		path: "/:experienceId",
		component: ReservationView,
	},
];

const router = createRouter({
	history: import.meta.env.VITE_HISTORY_MODE === 'web' ? createWebHistory('/book/') : createWebHashHistory('/book/'),
	base: '/book/',
	routes,
});

function hasQueryParams(route) {
	return !!Object.keys(route.query).length
}

router.beforeEach((to, from, next) => {
	if(!hasQueryParams(to) && hasQueryParams(from)){
		next({...to, query: from.query});
	} else {
		next();
	}
});

export default router;